import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
import { CartIcon, ArrowRightIcon } from './icons/Icons';
const CHECKOUT_URL = 'https://rutinasimple.com//cart/52838156763417:1';
type CtaButtonProps = {
  label?: string;
  price?: string;
  className?: string;
  fullWidth?: boolean;
  href?: string;
  checkoutHref?: string;
  trackingValue?: number;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  /**
   * When true, this is the single "buy" button that sends the user to the
   * selected Shopify checkout. When false (default), the button scrolls to `href`.
   */
  checkout?: boolean;
};
/**
 * The primary conversion button, reused across the page.
 * Warm amber "fire" gradient-free solid with a subtle animated shimmer
 * highlight and a spring press interaction.
 */
export function CtaButton({
  label = 'SÍ, QUIERO APAGAR EL ARDOR',
  price = 'ACCESO POR $10.99',
  className = '',
  fullWidth = true,
  href = '#oferta',
  checkoutHref = CHECKOUT_URL,
  trackingValue = 10.99,
  onClick,
  checkout = false
}: CtaButtonProps) {
  return <motion.a href={checkout ? checkoutHref : href} onClick={event => {
    onClick?.(event);
    if (checkout && !event.defaultPrevented) {
      trackAddToCart(trackingValue);
    }
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.97
  }} whileInView={{
    boxShadow: ['0 12px 30px -8px rgba(200,80,20,0.45)', '0 16px 42px -6px rgba(200,80,20,0.65)', '0 12px 30px -8px rgba(200,80,20,0.45)']
  }} viewport={{
    amount: 0.2
  }} transition={{
    boxShadow: {
      duration: 2.2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} className={`group relative inline-flex ${fullWidth ? 'w-full' : ''} items-center justify-center gap-3 overflow-hidden rounded-2xl bg-[#e0611f] px-6 py-5 text-center font-display font-extrabold uppercase tracking-wide text-white ${className}`} data-id="element-92" data-mp="39y7y82d1fe7m">
      <span className="pointer-events-none absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/25 to-transparent" data-id="element-93" data-mp="3mv4di1ri2h0c" />
      <CartIcon className="relative h-6 w-6 shrink-0" strokeWidth={2.4} data-id="element-94" data-mp="i4frws3few6" />
      <span className="relative flex flex-col items-center leading-tight sm:flex-row sm:gap-2" data-id="element-95" data-mp="3rwjxdqhxyhh5">
        <span className="text-base sm:text-lg" data-id="element-96" data-mp="9ikhb0pa0bye">{label}</span>
        <span className="text-sm font-bold text-amber-100 sm:text-base" data-id="element-97" data-mp="9gzq9l267b5a">
          — {price}
        </span>
      </span>
      <ArrowRightIcon className="relative h-5 w-5 shrink-0 transition-transform duration-300 group-hover:translate-x-1" data-id="element-98" data-mp="4lu3kk0y1sg5" />
    </motion.a>;
}